export default "__VITE_ASSET__BRXEtc4S__"